/**
 * Functions that operate on DOM elements
 *
 * @module component/util/domelement
 */

/**
 * Return true if a DOM element is visible.
 *
 * Note: it does not matter whether the element is in the viewport or not. This
 * means that if the element is offscreen to the user but still visible (eg css
 * style attribute style is not none), then this function will return true.
 *
 * @param {HTMLElement} el
 * The DOM element to check if visible or not
 *
 * @returns {boolean}
 *
 * @example
 * let hello = document.getElementById('world')
 * let visible = is_visible(hello)
 *
 */
export function is_visible(el) {
    return el.offsetParent !== null;
}

/**
 * Return true if a DOM element is within the viewport.
 *
 * The viewport is the area of the page that is displayed to the user in their
 * web browser.
 *
 * @param {Window} global
 * The global object (window in browser context)
 *
 * @param {Element} el
 * The DOM element to check if in the viewport or not
 *
 * @returns {boolean}
 *
 * @example
 * let hello = document.getElementById('world')
 * let viewable = in_viewport(window, hello)
 *
 */
export function in_viewport(global, el) {
    let doc = global.document.documentElement;
    let width = doc.clientWidth;
    let height = doc.clientHeight;
    let rect = el.getBoundingClientRect();
    let res =
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.right <= width &&
        rect.bottom <= height;

    return res;
}
